/*
 * The behavior plane: these declarations are the ones the taxonomy rejects in
 * structure and skin. They restore the 200ms colour/transform easing and the
 * pointer affordances the superseded toggle components had.
 */
.root {
  cursor: var(--cursor-ds-interactive);
}

.root:disabled {
  cursor: var(--cursor-ds-disabled);
}

.track {
  transition-property: var(--transition-ds-colors);
  transition-duration: var(--duration-ds-200);
  transition-timing-function: var(--easing-ds-standard);
}

.thumb {
  pointer-events: var(--pointer-events-ds-none);
  transition-property: var(--transition-ds-transform);
  transition-duration: var(--duration-ds-200);
  transition-timing-function: var(--easing-ds-standard);
}
